import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement de la composition...", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle text-success",
  style: {"font-size":"60px"}
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Vous avez utilisé tous vos essais", -1)
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-info text-center mb-4"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Vous avez déjà composé", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "mb-2 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "alert alert-warning d-inline-block px-4 py-2 mb-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createElementVNode("strong", null, "Important :"),
  /*#__PURE__*/_createTextVNode(" Seule la note du dernier essai sera retenue. ")
], -1)
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between mb-30" }
const _hoisted_20 = { class: "fw-bold mb-5" }
const _hoisted_21 = { class: "badge bg-primary fs-13" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1)
const _hoisted_23 = { class: "row mb-30" }
const _hoisted_24 = { class: "col-md-6 col-lg-3 mb-15" }
const _hoisted_25 = { class: "p-15 rounded-2 border text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar text-primary mb-5",
  style: {"font-size":"22px"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0 fs-13" }, "Date de composition:", -1)
const _hoisted_28 = { class: "col-md-6 col-lg-3 mb-15" }
const _hoisted_29 = { class: "p-15 rounded-2 border text-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-clock-o text-warning mb-5",
  style: {"font-size":"22px"}
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0 fs-13" }, "Date limite", -1)
const _hoisted_32 = { class: "col-md-6 col-lg-3 mb-15" }
const _hoisted_33 = { class: "p-15 rounded-2 border text-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-book text-success mb-5",
  style: {"font-size":"22px"}
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0 fs-13" }, "Matière", -1)
const _hoisted_36 = { class: "col-md-6 col-lg-3 mb-15" }
const _hoisted_37 = { class: "p-15 rounded-2 border text-center" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-list-ol text-info mb-5",
  style: {"font-size":"22px"}
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0 fs-13" }, "Nombre de questions", -1)
const _hoisted_40 = { class: "border rounded-2 p-15 mb-25 d-flex align-items-center gap-10" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-user-circle text-primary",
  style: {"font-size":"36px"}
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-muted fs-13" }, "Professeur responsable", -1)
const _hoisted_43 = { class: "alert alert-warning d-flex align-items-start gap-10 mb-25" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle mt-1" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("strong", null, "Instructions importantes :", -1)
const _hoisted_46 = { class: "mb-0 mt-5 ps-15" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Le formulaire se soumettra "),
  /*#__PURE__*/_createElementVNode("strong", null, "automatiquement"),
  /*#__PURE__*/_createTextVNode(" à la fin du temps imparti.")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("li", null, "Une fois la salle ouverte, vous ne pouvez pas revenir en arrière.", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("li", null, "Assurez-vous d'être dans un endroit calme avant de commencer.", -1)
const _hoisted_50 = {
  key: 1,
  class: "alert alert-danger text-center"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ban me-2" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("strong", null, "Cette composition est expirée.", -1)
const _hoisted_53 = {
  key: 2,
  class: "alert alert-info text-center mb-20"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-redo me-2" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("strong", null, "Nouvelle tentative :", -1)
const _hoisted_56 = {
  key: 3,
  class: "text-center mt-20"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sign-in me-8" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.dejaCompose && !_ctx.composition?.peutEncoreComposer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, [
                _createTextVNode(" Vous avez utilisé les "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.composition?.nombreEssaisAutorise), 1),
                _createTextVNode(" essai(s) autorisé(s) pour cette composition. ")
              ]),
              _createVNode(_component_router_link, {
                to: "/liste-compositions",
                class: "btn btn-outline-primary mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Retour à la liste ")
                ]),
                _: 1
              })
            ]))
          : (_ctx.composition)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.dejaCompose && _ctx.composition?.peutEncoreComposer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("p", _hoisted_16, [
                        _createTextVNode(" Vous avez utilisé "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.composition.tentativesEffectuees), 1),
                        _createTextVNode(" essai(s) sur "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.composition.nombreEssaisAutorise), 1),
                        _createTextVNode("."),
                        _hoisted_17,
                        _createTextVNode(" Il vous reste encore "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.composition.tentativesRestantes), 1),
                        _createTextVNode(" tentative(s). ")
                      ]),
                      _hoisted_18
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.composition.titre), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.composition.type), 1)
                  ]),
                  _createVNode(_component_router_link, {
                    to: "/liste-compositions",
                    class: "btn btn-outline-secondary btn-sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _createTextVNode(" Retour ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.composition.dateComposition)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _hoisted_31,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.composition.dateFinSoumission || _ctx.composition.dateComposition)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _hoisted_35,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.composition.filiereNiveauMatiere?.matiere?.libelle || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _hoisted_39,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.composition.compoQuestions?.length || 0) + " questions", 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", null, [
                    _hoisted_42,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.fullName(_ctx.composition.professeur)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", null, [
                    _hoisted_45,
                    _createElementVNode("ul", _hoisted_46, [
                      _createElementVNode("li", null, [
                        _createTextVNode("Vous disposez de "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.composition.dureeMinutes) + " minutes", 1),
                        _createTextVNode(" pour répondre à toutes les questions.")
                      ]),
                      _hoisted_47,
                      _hoisted_48,
                      _hoisted_49
                    ])
                  ])
                ]),
                (_ctx.estExpiree)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      _hoisted_52,
                      _createTextVNode(" Vous ne pouvez plus y participer. ")
                    ]))
                  : (_ctx.dejaCompose && _ctx.composition?.peutEncoreComposer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _hoisted_54,
                        _hoisted_55,
                        _createTextVNode(" Vous êtes sur le point de commencer l'essai n°"),
                        _createElementVNode("strong", null, _toDisplayString((_ctx.composition.tentativesEffectuees || 0) + 1), 1),
                        _createTextVNode(". ")
                      ]))
                    : _createCommentVNode("", true),
                (!_ctx.estExpiree && (!_ctx.dejaCompose || _ctx.composition?.peutEncoreComposer))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("button", {
                        class: "btn btn-success btn-lg px-40 fw-bold",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.entrerDansLaSalle && _ctx.entrerDansLaSalle(...args)))
                      }, [
                        _hoisted_57,
                        _createTextVNode(" " + _toDisplayString(_ctx.dejaCompose ? 'Recommencer la composition' : 'Entrer dans la salle'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}